/**
 * PATH: apps/quote/src/components/builder/unified-bottom-bar/PanelToggles.tsx
 * PURPOSE: Panel toggle buttons for workspace panels
 */

import { Keyboard, Columns3, PanelLeft, Settings2, FolderOpen, Bot } from 'lucide-react'
import { cn } from '@/lib/utils'
import { useWorkspace, type RightDrawerTab } from '../BuilderWorkspace'

function ToggleBtn({ active, onClick, icon: Icon, title, variant = 'default' }: {
  active: boolean; onClick: () => void; icon: React.ComponentType<{ className?: string }>; title: string; variant?: 'default' | 'ai'
}) {
  return (
    <button onClick={onClick} className={cn('p-1 rounded transition-colors',
      active ? (variant === 'ai' ? 'bg-purple-100 dark:bg-purple-900/30 text-purple-600 dark:text-purple-400' : 'bg-blue-100 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400')
      : 'text-slate-400 hover:text-slate-600 dark:hover:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-800'
    )} title={title}><Icon className="w-3.5 h-3.5" /></button>
  )
}

export function PanelToggles() {
  const { leftPanelOpen, toggleLeftPanel, rightDrawerOpen, rightDrawerTab, closeRightDrawer, setRightDrawerTab, showKeyboardHints, toggleKeyboardHints, gridView, toggleGridView } = useWorkspace()

  const handleRightToggle = (tab: RightDrawerTab) => {
    if (rightDrawerOpen && rightDrawerTab === tab) closeRightDrawer()
    else setRightDrawerTab(tab)
  }

  return (
    <div className="flex items-center gap-0.5 border-l border-slate-200 dark:border-slate-700 pl-2 ml-2">
      <ToggleBtn active={showKeyboardHints} onClick={toggleKeyboardHints} icon={Keyboard} title="Toggle keyboard hints" />
      <ToggleBtn active={gridView === 'compact'} onClick={toggleGridView} icon={Columns3} title={`Toggle columns view (currently ${gridView})`} />
      <ToggleBtn active={leftPanelOpen} onClick={toggleLeftPanel} icon={PanelLeft} title="Toggle sections panel" />
      <ToggleBtn active={rightDrawerOpen && rightDrawerTab === 'inspector'} onClick={() => handleRightToggle('inspector')} icon={Settings2} title="Toggle inspector" />
      <ToggleBtn active={rightDrawerOpen && rightDrawerTab === 'context'} onClick={() => handleRightToggle('context')} icon={FolderOpen} title="Toggle context" />
      <ToggleBtn active={rightDrawerOpen && rightDrawerTab === 'ai'} onClick={() => handleRightToggle('ai')} icon={Bot} title="Toggle AI assistant" variant="ai" />
    </div>
  )
}
